module.exports = __webpack_public_path__ + "static/fl-9-video-29c2a01529375369d04bb46c0588fd8c.mp4";